import type {
  InitialData,
  AccessibilityWizardPanelState,
} from '@wix/a11y-wizard';

import type { SlotKey } from 'repluggable';

export interface A11yWizardStateAPI {
  getInitialData: () => InitialData | undefined;
  getPanelState: () => AccessibilityWizardPanelState | undefined;
  setInitialData: (initialData: InitialData) => void;
  setPanelState: (
    panelState: AccessibilityWizardPanelState | undefined,
  ) => void;
}

export const A11yWizardStateAPI: SlotKey<A11yWizardStateAPI> = {
  name: 'A11yWizardStateAPI',
  layer: 'DERIVATIVE_STATE',
  public: false,
};
